import { Typography, Divider } from "@material-ui/core";
import { useParams, Link } from "react-router-dom";
import ComprehensionQuestionCard from "../ComprehensionQuestionCard";
import AssignmentReading from "../AssignmentReading";
import BackButton from "./BackButton";
import ReadingReport from "../ReadingReport";
import { PageLabel } from "../PageLabel";
import useParamsSelector, { getStudent, getAssignment } from "../../selectors";

const AssignmentReport = () => {
  const { classId } = useParams<{ classId: string }>();
  const student = useParamsSelector(getStudent);
  const assignment = useParamsSelector(getAssignment);
  return (
    <div className="assignmentReport">
      <PageLabel label="Student Submission">
        <BackButton />
      </PageLabel>
      <div className="headers">
        <Link to={`/Class/${classId}/Student/${student?.uid}`}>
          <Typography className="studentName" variant="h2">
            {student?.firstName} {student?.lastName}
          </Typography>
        </Link>{" "}
        -{" "}
        <Link to={`/Assignments/${assignment?.id}`}>
          <Typography className="assignmentName" variant="h1">
            {assignment?.assignmentDetails.title}
          </Typography>
        </Link>
      </div>
      <Divider />
      <br />
      <br />
      <ReadingReport />
      <ComprehensionQuestionCard />
      <AssignmentReading />
    </div>
  );
};
export default AssignmentReport;
